@if (auctionItem) {
  <div class="auction-detail">
    <h2 class="auction-detail__openingPrice" data-test-id="app-auto-vision-auction-detail-e-header">
      <span>{{ autoVisionAuctionDetailTranslations.salePrice }} </span>
      <span>{{ formatCurrency(auctionItem?.salePrice) }}</span>
    </h2>
    <div class="auction-detail__status fw-bold">
      <app-auction-badge text="{{autoVisionAuctionDetailTranslations.sold}}" data-test-id="app-auto-vision-auction-detail-e-badge" variant="success"></app-auction-badge>
    </div>
    <div class="auctionTime">
      <ul class="list-unstyled">
        <li class="m-0">
          <app-datalist-item
            label={{autoVisionAuctionDetailTranslations.saleDateTime}}
            identifier="sold_vdp_sale_date"
            value="{{ localizeDate(auctionItem?.saleDate) }}"
            >
          </app-datalist-item>
        </li>
        <li class="m-0">
          <app-datalist-item identifier="active_vdp_posted_date"
            label={{autoVisionAuctionDetailTranslations.posted}} value="{{ auctionItem?.postedDateTime ? localizeDate(auctionItem?.postedDateTime) : 'N/A' }}">
          </app-datalist-item>
        </li>
        <li class="m-0">
          <ng-container>
            <app-datalist-item
              identifier="auto_vision_msrp"
              label={{autoVisionAuctionDetailTranslations.msrp}}
              value="{{ auctionItem?.msrp ? formatCurrency(auctionItem?.msrp) : 'N/A' }}">
            </app-datalist-item>
          </ng-container>
        </li>
      </ul>
    </div>
  </div>
}
